import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl, FormGroup} from "@angular/forms";

/**
 * Dialog data
 */
export class DialogInputData {

  /** Dialog title */
  title: string;

  /** Text placeholder */
  placeholder: string;

  /** Pre defined text */
  text: string;

  constructor(title: string, placeholder = '', text = '') {
    this.title = title;
    this.placeholder = placeholder;
    this.text = text;
  }
}

/**
 * Delete dialog template
 *
 * Using with MatDialog:
 *
 ```
 // Open dialog
 const dialogRef = this.dialog.open(DialogInputComponent, {
     data: new DialogInputData('Type here!')
 });

 // Callback for when dialog is closed
 const result = dialogRef.afterClosed().toPromise()
 ```
 */
@Component({
  selector: 'kis-dialog-input',
  templateUrl: './dialog-input.component.html',
  styleUrls: ['./dialog-input.component.scss']
})
export class DialogInputComponent implements OnInit {

  /** Dialog input form */
  form = new FormGroup({
    input: new FormControl('')
  });

  /**
   * @param dialogRef - to use dialog operations
   * @param data - data to be injected
   */
  constructor(public dialogRef: MatDialogRef<DialogInputComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogInputData) {
    if (data.text) {
      this.form.get('input').setValue(data.text);
    }
  }

  ngOnInit(): void {
  }

  submit() {
    this.dialogRef.close(this.form.get('input').value);
  }

}
